import { useContext } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom';
import MessagesContext from '../../contexts/messagesContext';
const hasNumber = (string) => {
    return /\d/.test(string);
};
const listOfCrumbs = () => {
    const params = useParams();
    const { pathname } = useLocation();
    const { messages } = useContext(MessagesContext);
    const pathNames = pathname.split('/').filter((item) => item);
    const length = pathNames?.length;
    const lastParam = pathNames[length - 1];
    const oneLeftToLast = pathNames[length - 2];
    const formStructure = useSelector((state) => state.dynamicForms.formStructure);
    const reportId = useSelector((state) => state.reports?.form?.reportId);
    const formName = formStructure?.title;
    const commonPath = `patient/${params.id}`;

    const data = [
        {
            route: 'patients',
            crumbsList: [{ title: messages.listOfPatients }]
        },
        {
            route: 'appointment/day',
            crumbsList: [{ title: messages.appointments }, { title: messages.day }]
        },
        {
            route: 'appointment/week',
            crumbsList: [{ title: messages.appointments }, { title: messages.week }]
        },
        {
            route: 'setting/manageForms',
            crumbsList: [
                { title: messages.setting },
                { title: messages.permissionsTitle.manage_form }
            ]
        },
        {
            route: 'setting/reports',
            crumbsList: [
                { title: messages.setting },
                { title: messages.permissionsTitle.aggregate_data }
            ]
        },
        {
            route: 'setting/manageUsers',
            crumbsList: [
                { title: messages.setting },
                { title: messages.permissionsTitle.manage_user }
            ]
        },
        {
            route: 'setting/manageClinics',
            crumbsList: [
                { title: messages.setting },
                { title: messages.permissionsTitle.manage_clinic }
            ]
        },
        {
            route: 'profile',
            crumbsList: [{ title: messages.profile }],
            isMobile: true
        },
        {
            route: 'add-patient',
            crumbsList: [{ title: messages.newPatient }],
            isMobile: true
        },
        {
            route: `${commonPath}/forms`,
            crumbsList: [{ title: messages.sidebar.visit }]
        },
        {
            route: `${commonPath}/forms/form/${hasNumber(lastParam) && lastParam}`,
            crumbsList: [
                { title: messages.sidebar.visit },
                { title: messages.sidebar.form },
                { title: formName, tooltip: lastParam }
            ]
        },
        {
            route: `${commonPath}/forms/form/newForm`,
            crumbsList: [{ title: messages.sidebar.visit }, { title: messages.sidebar.newForm }],
            isMobile: false
        },
        {
            route: `${commonPath}/forms/form/newForm`,
            crumbsList: [{ title: messages.sidebar.visit }, { title: messages.sidebar.form }],
            isMobile: true
        },
        {
            route: `${commonPath}/forms/comparison/${lastParam}`,
            crumbsList: [
                { title: messages.sidebar.visit },
                { title: messages.comparison },
                { title: formName, tooltip: lastParam }
            ]
        },
        {
            route: `${commonPath}/forms/form`,
            crumbsList: [{ title: messages.sidebar.visit }, { title: messages.sidebar.form }],
            isMobile: true
        },
        {
            route: `${commonPath}/forms/comparison`,
            crumbsList: [{ title: messages.sidebar.visit }, { title: messages.comparison }],
            isMobile: true
        },
        {
            route: `${commonPath}/laboratory`,
            crumbsList: [{ title: messages.sidebar.laboratory }]
        },
        {
            route: `${commonPath}/laboratory/images_result/new`,
            crumbsList: [
                { title: messages.sidebar.laboratory },
                { title: messages.images },
                { title: messages.new }
            ]
        },
        {
            route: `${commonPath}/laboratory/images_result/${lastParam}`,
            crumbsList: [
                { title: messages.sidebar.laboratory },
                { title: messages.images },
                { title: lastParam }
            ]
        },
        {
            route: `${commonPath}/laboratory/result/form/new`,
            crumbsList: [
                { title: messages.sidebar.laboratory },
                { title: messages.sidebar.test },
                { title: messages.new }
            ]
            // isMobile: true
        },
        {
            route: `${commonPath}/laboratory/result/form/${oneLeftToLast}/${lastParam}`,
            crumbsList: [
                { title: messages.sidebar.laboratory },
                { title: messages.sidebar.test },
                { title: oneLeftToLast }
            ]
            // isMobile: true
        },
        {
            route: `${commonPath}/radiology`,
            crumbsList: reportId
                ? [{ title: messages.sidebar.radiology }, { title: reportId }]
                : [{ title: messages.sidebar.radiology }]
        },
        {
            route: `${commonPath}/radiology/detail`,
            crumbsList: [{ title: messages.sidebar.radiology }, { title: reportId }],
            isMobile: true
        },
        {
            route: `${commonPath}/radiology/form`,
            crumbsList: [{ title: messages.sidebar.radiology }, { title: messages.sidebar.form }],
            isMobile: true
        },
        {
            route: `${commonPath}/medication`,
            crumbsList: [{ title: messages.sidebar.medication }]
        },
        {
            route: `${commonPath}/appointments`,
            crumbsList: [{ title: messages.sidebar.appointment }]
        },
        {
            route: `${commonPath}/profile`,
            crumbsList: [{ title: messages.sidebar.patientFile }]
        },
        {
            route: 'statistics',
            crumbsList: [{ title: messages.statistics }]
        },
        {
            id: 25,
            route: 'search',
            crumbsList: [{ title: messages.search }]
        }
    ];
    return { data };
};

export default listOfCrumbs;
